export { default } from './TypesOfInsurance';
